// extracted by mini-css-extract-plugin
module.exports = {"searchResultHeader":"SearchPage_searchResultHeader_3TtwD","spinAround":"SearchPage_spinAround_1JPOv"};